import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './redesign.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import App from './App';

console.log('Index file loaded');

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
console.log('Root element found:', document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
